export default __webpack_public_path__ + "static/media/user_card.a6143582.png";